import {VehicleType} from './types';

export const MockData: VehicleType[] = [
  {id: 25, name: 'Car'},
  {id: 35, name: 'Paxter'},
  {id: 45, name: 'Trolley'},
];
